import { request } from '@/helpers/apiClient'
import { ONLINE_ORDER_CONFIG} from '@/utils/constants/apiConfig/Orders/onlineOrderConfig'

export const getOnlineOrder = (body, queryParams) => request(ONLINE_ORDER_CONFIG.ONLINE_ORDER(queryParams), { data: body })

export const getOnlineOrderCsvFile = (body, queryParams) => request(ONLINE_ORDER_CONFIG.ONLINE_ORDER_CSV_DOWNLOAD(queryParams), { data: body })